import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../redux/configureStore';
import Wrapper from '../../../../shared/components/Wrapper';
import ApurationDashboard from './components/ApurationDashboard';
import FaresFilter from './components/FaresFilter';
import FrameFlex from './components/Frames';

function ApurationApp() {
  const apurationDataState = useSelector(
    (reducer: IReducer) => reducer.apurationAppData
  );

  const loading = useMemo(() => {
    if (apurationDataState.isLoading === true) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [apurationDataState.isLoading]);

  const TableComponent = useMemo(() => {
    if (apurationDataState.gotSuccess) {
      return (
        <>
          <ApurationDashboard />
        </>
      );
    }
    return <></>;
  }, [apurationDataState.gotSuccess]);

  return (
    <>
      <FrameFlex.Base>
        <FaresFilter />
        {loading}
        {TableComponent}
      </FrameFlex.Base>
    </>
  );
}

export default ApurationApp;
